﻿import React, { Fragment, useState, useEffect, useCallback } from 'react';
import moment from 'moment';

const FacilityInfoItem = ({ STP, facilityInfo, lang }) => {
	const currentLanguage = document.querySelector('html').getAttribute('lang');

	return facilityInfo && (
		<div className='facilitysearchpage__listitem__facilityinfo'>
			{!facilityInfo.GiantLeapLink && (facilityInfo.HasLTPBookableOnline || facilityInfo.HasLTPNotBookableOnline) && facilityInfo.HasSTP ?
				lang.ltpandstpexplanation :''}
			{!facilityInfo.GiantLeapLink && !(facilityInfo.HasLTPBookableOnline || facilityInfo.HasLTPNotBookableOnline) && facilityInfo.HasSTP ?
				lang.stpexplanation : ''}
			{(!facilityInfo.GiantLeapLink && (facilityInfo.HasLTPBookableOnline || facilityInfo.HasLTPNotBookableOnline) && !facilityInfo.HasSTP) ?
				lang.ltpexplanation : ''}
			{(!facilityInfo.GiantLeapLink && !(facilityInfo.HasLTPBookableOnline || facilityInfo.HasLTPNotBookableOnline) && !facilityInfo.HasSTP) ?
				'Varken LTP eller STP' : ''}
			{facilityInfo.FilteredNotes && <div className="facilitysearchpage__listitem__facilityinfo__rentalinstructions">{facilityInfo.FilteredNotes}</div>}
			<div className="showonmap">{facilityInfo.Address} {facilityInfo.DrivingInstructions && <span>{facilityInfo.DrivingInstructions}</span>}</div>
			<div className="facilitysearchpage__listitem__facilityinfo__openinghours">
				{(STP && facilityInfo.HasSTP && facilityInfo.GroupedTimeSlots) ?
				<>
				<h4>{lang.openinghours}</h4>
					<ul>
						{facilityInfo.GroupedTimeSlots.map(g =>
							<li key={g.BothDays+g.InTimes}>
								<div>{g.BothDays} <span>{lang.entry} {g.InTimes}</span><span>{lang.exit} {g.OutTimes}</span></div>
							</li>
						)}
					</ul>
				</>
				: !facilityInfo.HasSTP && <p>{lang.noshortterm}</p>}

				{!STP && facilityInfo.LongTermOpeningHours &&
				<>
						<h4>{lang.openinghoursltp}</h4>
						<ul>
					<li dangerouslySetInnerHTML={{ __html: facilityInfo.LongTermOpeningHours }}></li>
					</ul>
				</>
				}
			</div>
			{facilityInfo.FacilityInfo && <div className="facilitysearchpage__listitem__facilityinfo__aboutfacility">
				<h4>{lang.facilityinformation}</h4>
				<ul>
					<li>{lang.numberofparkingspots}:<span>{facilityInfo.NumberOfParkingSpots ? facilityInfo.NumberOfParkingSpots : '–'}</span></li>
					<li>{lang.numberofevparkingspots}:<span>{facilityInfo.FacilityInfo.NumberOfEvChargingSpaces ?? '0'}</span></li>
					<li>{lang.height}:<span>{facilityInfo.FacilityInfo.MaxVehicleHeight ? (facilityInfo.FacilityInfo.MaxVehicleHeight / 100) + " m" : '–'}</span></li>
					<li>{lang.indoors}:<span>{facilityInfo.FacilityInfo.Indoors ? lang.yes : lang.no}</span></li>
					<li>{lang.heated}:<span>{facilityInfo.FacilityInfo.Heated ? lang.yes : lang.no}</span></li>
				</ul>
			</div>}
		</div>
	)
}

export default FacilityInfoItem;
